/**
 * Removes accents from vowels and certain special characters in a string.
 *
 * This function replaces accented Latin vowels (A, E, I, O, U, a, e, i, o, u),
 * as well as 'N', 'n', 'C', and 'c' with their unaccented equivalents.
 * It is primarily intended for use in slugification and normalization routines.
 *
 * @param {string} rawString - The input string to process.
 * @returns {string} The string with accented vowels and certain special characters replaced by their unaccented forms.
 *
 * @example
 * ```ts
 * stripVowelAccent('Crème Brûlée'); // 'Creme Brulee'
 * stripVowelAccent('ÀÉÎÕÜñç'); // 'AEIOUnc'
 * ```
 * @internal
 */
function stripVowelAccent(rawString) {
    const rExps = [
        { re: /[\xC0-\xC6]/g, ch: 'A' }, // ÀÁÂÃÄÅ
        { re: /[\xE0-\xE6]/g, ch: 'a' }, // àáâãäå
        { re: /[\xC8-\xCB]/g, ch: 'E' }, // ÈÉÊË
        { re: /[\xE8-\xEB]/g, ch: 'e' }, // èéêë
        { re: /[\xCC-\xCF]/g, ch: 'I' }, // ÌÍÎÏ
        { re: /[\xEC-\xEF]/g, ch: 'i' }, // ìíîï
        { re: /[\xD2-\xD6]/g, ch: 'O' }, // ÒÓÔÕÖ
        { re: /[\xF2-\xF6]/g, ch: 'o' }, // òóôõö
        { re: /[\xD9-\xDC]/g, ch: 'U' }, // ÙÚÛÜ
        { re: /[\xF9-\xFC]/g, ch: 'u' }, // ùúûü
        { re: /[\xD1]/g, ch: 'N' }, // Ñ
        { re: /[\xF1]/g, ch: 'n' }, // ñ
        { re: /Ç/g, ch: 'C' }, // Ç
        { re: /ç/g, ch: 'c' }, // ç
    ];
    for (let i = 0, len = rExps.length; i < len; i = i + 1) {
        rawString = rawString.replace(rExps[i].re, rExps[i].ch);
    }
    return rawString;
}

export { stripVowelAccent };
//# sourceMappingURL=stripVowelAccent.js.map
